import _isEqual from 'lodash/isEqual';
import scrollToElement from 'scroll-to-element';
import { removeStoredResponse } from '../../../appState/ducks/listingPageProducts';
import { getCacheTimeout } from '../../../appState/ducks/network';

export function isChannelAvailable(channelType) {
  return [
    'collectInStoreAvailable',
    'homeDeliveryAvailable',
    'supplierDeliveryAvailable',
    'orderNowDeliveryLaterAvailable'
  ].includes(channelType);
}

export function createMarkup(markupValue) {
  return { __html: markupValue };
}

export function getCurrentPaginatorPage() {
  return window.appState.getState().listingPage.pagination.pageList.find(
    (page) => page.isCurrent
  );
}

export function getCurrentUCMS() {
  return window.appState.getState().listingPage.pageSetup.category;
}

export function getCurrentFiltersSetup() {
  const state = window.appState.getState();
  return {
    pageNumber: getCurrentPaginatorPage() ? getCurrentPaginatorPage().label : 0,
    filters: state.listingPage.filters.list
  };
}

export function getActiveStoredResponse() {
  return window.appState.getState().listingPage.products.storedResponses.find(
    (response) => response.isActive
  );
}

export function getCurrentProductList() {
  const currentStoredResponse = getActiveStoredResponse();
  if (!currentStoredResponse) {
    return [];
  }
  return currentStoredResponse.data.productList;
}

export function getCurrentRenderedProductIds() {
  return getCurrentProductList().map(
    (product) => product.id
  );
}

export function getNumberOfProductsPerRowInGrid(windowWidth) {
  if (windowWidth <= 599) {
    return 2;
  } if (windowWidth > 599 && windowWidth < 769) {
    return 3;
  }
  return 4;
}

export function findStoredValidResponse(searchCriteria) {
  const response = window.appState.getState().listingPage.products.storedResponses.find(
    (storedResponse) => _isEqual(
      storedResponse.request,
      searchCriteria
    )
  );

  if (response) {
    // Check if response is still valid. If not, remove it from redux store.
    if ((Date.now() - response.timeFetched) < getCacheTimeout()) {
      return response;
    }
    window.appState.dispatch(removeStoredResponse(response.uuid));
    return null;
  }
  return null;
}

export function scrollToResultsMessage() {
  scrollToElement('[data-component="list-page-results-message"]', {
    ease: 'linear',
    duration: 300
  });
}
